import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { t } from '../../../../../locales';
import {
  getCustomerIsCwp,
  getCustomerIsLife,
  getLanguage,
} from '../../../../../selectors/userSelectors';
import './styles.scss';
import {
  getMarketPlaceNewsApiUrl,
  getCorpWebUrl,
} from '../../../../../selectors/configSelectors';

import {
  addCorpWebIndicator,
  CorpWebIndicatorConfig,
} from '../../../../../utils/emmaUrlConverter';
import { getCorpWebIndicatorConfig } from '../../../../emma-webview/selectors/webviewSelector';
import { getHomePromotions } from '../../../../emma-axa-promotional-offer/selectors/promoSelectors';
import _ from 'lodash';
import { startBannerRouting } from '../../../../emma-common/actions/bannerRoutingActions';
import NewsListContent from './ab-test/components/NewsListContent';
import withNewsListContentABTestHOC from './ab-test/withNewsListContentABTestHOC';
import EmmaPromoBanner from '../../../../../../src/components/EmmaNewsSlick';
import { goto } from '../../../../../../src/actions/historyActions';

const MarketPlaceNews: any = () =>
  // props: {
  // news: Array<any>;
  // newsApiLink: any;
  // corpWebIndicator: CorpWebIndicatorConfig;
  // customerContentoType: string[];
  // corpWebUrl: string;
  // gaLob: string;
  // }
  {
    const lang = getLanguage();
    // ABTest POC: Housekeep for future reference when implementing Emma1.5 Revamp
    // const WrappedNewsListContent = withNewsListContentABTestHOC(NewsListContent);

    const gotoMyPrivileges = () => {
      goto('emma-my-privileges/offers-tab');
    };

    return (
      <div className="news-list__wrapper promotion__wrapper">
        <div className="news-list__header">
          <div className="news-list__title">{t('HOMEPAGE_AXA_NEWS_TITLE')}</div>
          <div className="news-list__toggle-wrapper">
            <div className="news-list__toggle-btn" onClick={gotoMyPrivileges}>
              <span className="news-list__toggle-label--desktop">
                {t('HOMEPAGE_MARKETPLACE_SEE_ALL_SERVICE')}
              </span>
            </div>
          </div>
        </div>
        <EmmaPromoBanner lang={lang as 'en' | 'zh'} />
      </div>
    );
  };

export default MarketPlaceNews;

// const mapStateToProps = (state: any) => {
// const newsApiLink: any = getMarketPlaceNewsApiUrl(state);
// const promo = getHomePromotions(state);
// const gaLob = getCustomerIsLife(state)
//   ? 'Life'
//   : getCustomerIsCwp(state)
//   ? 'CWP'
//   : '';

/** Removed by HKEMMA-41562 - pointed to new /banner API. No profile filter on Frontend. */
// const customerContentoType = getCustomerContentoType(state);
// if(news) {
//     news = news.filter((item:any) => !item.profile || customerContentoType.includes(item.profile))
// }

// const listingDeepLink =
//   newsApiLink && newsApiLink.listingDeepLink
//     ? newsApiLink.listingDeepLink
//     : '';
// const url =
//   listingDeepLink.query && listingDeepLink.query.url
//     ? listingDeepLink.query.url
//     : '';
// if (newsApiLink && url) {
//   newsApiLink.listingDeepLink.query.url = addCorpWebIndicator({
//     url,
//     ...getCorpWebIndicatorConfig(state),
// });
// }

// return {
// news: promo.data,
// newsApiLink: getMarketPlaceNewsApiUrl(state),
// corpWebIndicator: getCorpWebIndicatorConfig(state),
// corpWebUrl: getCorpWebUrl(state),
// gaLob,
// };
// };

// export default connect(mapStateToProps, null)(MarketPlaceNews);
